import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import http from "@/api";
import { AlertTriangle } from "lucide-react";

export default function DataIssuesPanel() {
  const [data, setData] = useState(null);

  useEffect(() => {
    http.get("/admin/supplier-data-issues").then((r) => setData(r.data)).catch(() => {});
  }, []);

  if (!data) return null;
  const hasIssues = data.flagged.length > 0 || data.duplicate_sap.length > 0 || data.duplicate_names.length > 0;
  if (!hasIssues) return null;

  return (
    <div className="sketch-border bg-[#FFFBEA] border-[#D4A437] p-5 mb-6" data-testid="data-issues-panel">
      <div className="font-hand text-lg text-[#8a6d1f] flex items-center gap-1.5">
        <AlertTriangle size={15} /> datos por revisar con Florencia
      </div>
      {data.flagged.length > 0 && (
        <div className="mt-2">
          <div className="text-xs uppercase tracking-wider font-bold text-[#8a6d1f]">Pendientes de validación ({data.flagged.length})</div>
          <ul className="mt-1 space-y-1">
            {data.flagged.map((s) => (
              <li key={s.id} className="text-sm" data-testid={`flagged-${s.id}`}>
                <Link to={`/proveedores/${s.id}`} className="font-semibold text-[var(--lala-blue)] hover:underline">{s.name}</Link>
                <span className="text-xs text-[var(--ink-soft)]"> — {s.data_review_note}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
      {data.duplicate_sap.length > 0 && (
        <div className="mt-2 text-sm">
          <span className="text-xs uppercase tracking-wider font-bold text-[#8a6d1f]">SAP IDs duplicados: </span>
          {data.duplicate_sap.map((d) => `${d.sap_id} (${d.suppliers.map((x) => x.name).join(" / ")})`).join(" · ")}
        </div>
      )}
      {data.duplicate_names.length > 0 && (
        <div className="mt-1 text-sm">
          <span className="text-xs uppercase tracking-wider font-bold text-[#8a6d1f]">Nombres duplicados: </span>
          {data.duplicate_names.map((d) => d.name).join(" · ")}
        </div>
      )}
      <div className="text-xs text-[var(--ink-soft)] mt-2">{data.missing_rfc_count} proveedores sin RFC (Florencia enviará RFCs y razón social).</div>
    </div>
  );
}
